import type { StateCreator } from 'zustand';
import type { LatLng } from '@/shared/types';
import type { BoundStore } from './store.types';

export type LocationSlice = {
	selectedPlace: LatLng | null;
	setSelectedPlace: (place: LatLng | null) => void;
};

const createLocationSlice: StateCreator<BoundStore, [], [], LocationSlice> = (
	set,
) => ({
	selectedPlace: null,
	setSelectedPlace: (selectedPlace) => set({ selectedPlace }),
});

export default createLocationSlice;
